import './src/style_electronics.css'

